import lightTheme from './themes/js/light-theme';
import darkTheme from './themes/js/dark-theme';
import suTheme from './themes/js/su-theme';

const doReturnTheme = (currentTheme) => {
  switch (currentTheme) {
    case 'light':
      return lightTheme;

    case 'dark':
      return darkTheme;

    case 'su':
      return suTheme;

    default:
      return lightTheme;
  }
};

export default doReturnTheme;
